module.exports = __webpack_public_path__ + "static/media/Country-Club-Villiage-Bylaws-and-Amendments.312b3034.pdf";